import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LibContentLoaderComponent } from './content-loader.component';

@NgModule({
  declarations: [
    LibContentLoaderComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinner
  ],
  exports: [
    LibContentLoaderComponent
  ]
})
export class LibContentLoaderModule { }
